import { useQuery, UseQueryResult } from '@tanstack/react-query';

import { fetchAllUsers, User } from '../queries/getAllUsers';

export function useGetAllUsers(): UseQueryResult<User[]> {
  return useQuery<User[]>({
    queryKey: ['users'],
    queryFn: fetchAllUsers,
  });
}
